import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    { path: '', redirectTo: '/home', pathMatch: 'full'}
];

export const RoutingProvider = RouterModule.forRoot(routes, { useHash: true });